import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './device.reducer';

export const DeviceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deviceEntity = useAppSelector(state => state.device.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceDetailsHeading">
          <Translate contentKey="cabmanApp.device.detail.title">Device</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="cabmanApp.device.type">Type</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.type}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="cabmanApp.device.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.serialNumber}</dd>
          <dt>
            <span id="model">
              <Translate contentKey="cabmanApp.device.model">Model</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.model}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="cabmanApp.device.name">Name</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.name}</dd>
          <dt>
            <span id="vendorData">
              <Translate contentKey="cabmanApp.device.vendorData">Vendor Data</Translate>
            </span>
          </dt>
          <dd>{JSON.stringify(deviceEntity.vendorData, null, 2)}</dd>
          <dt>
            <Translate contentKey="cabmanApp.device.fleet">Fleet</Translate>
          </dt>
          <dd>{deviceEntity.fleet ? deviceEntity.fleet.id : ''}</dd>
          <dt>
            <Translate contentKey="cabmanApp.device.station">Station</Translate>
          </dt>
          <dd>{deviceEntity.station ? deviceEntity.station.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/device" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device/${deviceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceDetail;
